// extracted by mini-css-extract-plugin
export default {"_":"ParameterMenu____A5zRi","wrapper":"ParameterMenu_wrapper__Nj1+A","mobile":"ParameterMenu_mobile__cK0bJ"};